module.exports = __webpack_public_path__ + "img/propStatus0.bc75e442.png";